module.exports = __webpack_public_path__ + "static/media/grayBgLogo.3e666bf9.png";